var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "eu-display_flex footer-container eu-align-items_center" },
      [
        _c("div", { staticClass: "eu-justify_center footer-information" }, [
          _c(
            "span",
            {
              staticClass: "account-name",
              attrs: { id: "userName", title: _vm.profile.user.first_name },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.profile.user.first_name) +
                  " " +
                  _vm._s(_vm.profile.user.last_name)
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "account-email",
              attrs: { id: "userEmail", title: _vm.profile.user.email },
            },
            [_vm._v(_vm._s(_vm.profile.user.email))]
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "emd-dropdown _position_left jsDropdown",
            attrs: { "data-onboarding": "profile" },
          },
          [
            _c(
              "emd-dropdown",
              {
                staticClass: "popover",
                attrs: { isOpen: _vm.selectOpenned, fixed: false },
                on: {
                  toggle: function ($event) {
                    _vm.selectOpenned = $event
                  },
                  close: function ($event) {
                    _vm.selectOpenned = false
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function () {
                      return [
                        _c(
                          "span",
                          [
                            _c(
                              "emd-tippy",
                              {
                                staticClass:
                                  "emd-action-button _has-tooltip popover-trigger",
                                attrs: {
                                  id: "settings",
                                  type: "ghost",
                                  position: "left",
                                  content: _vm.$t("tooltip.settings"),
                                },
                              },
                              [
                                _c("emerald-icon", {
                                  attrs: { icon: "ellipsis" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                [
                  _c(
                    "div",
                    {
                      staticClass: "emd-dropdown__content__item popover-items",
                    },
                    [
                      _c(
                        "ul",
                        _vm._l(_vm.popoverItems, function (item) {
                          return _c("li", { key: item.title }, [
                            _c(
                              "button",
                              {
                                staticClass: "popover-button",
                                on: { click: item.action },
                              },
                              [_vm._v(" " + _vm._s(item.title) + " ")]
                            ),
                          ])
                        }),
                        0
                      ),
                    ]
                  ),
                ],
              ],
              2
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }